<template>
  <v-container class="pa-0">
    <div class="line-bc">
      <div class="balloon6">
        <div class="faceicon">
          <img :src="iconUrl" />
        </div>
        <div class="chatting">
          <div class="says-border">
            <span v-html="bubbleContentHtml" />
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  ORDER_STATUS_TEXT_TYPE,
  getOrderStatusTextType,
} from "../../constants/order_constants";

export default {
  name: "OrderDetailBubble",
  components: {},
  props: {
    order: Object,
  },

  data: () => ({
    bubbleContentHtml: "",
  }),
  created() {},
  mounted() {
    this.initBubbleContent(this.order);
  },
  computed: {
    ...mapGetters(["progress", "iconUrl"]),
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress"]),
    initBubbleContent: function (order) {
      const orderTime = this.$options.filters.momentJS(
        order.createdAt,
        "YYYY/MM/DD HH:mm"
      );
      const visitTimeHHMM = this.$options.filters.momentJS(
        order.visitTime,
        "HH:mm"
      );
      const orderNo = order.orderNo;
      const content1 = `<span class="text-body-1">${orderTime}</span>`;
      const content2 = `<span class="text-body-2">注文番号</span><span class="ml-4 text-h5">${orderNo}</span>`;
      const content3 = `<span class="text-body-2">受取時間</span><span class="ml-4 text-h6">${visitTimeHHMM}</span>`;

      // 注文状態
      let content = `${content1}<br/>${content2}<br/>${content3}`;
      if (this.isShowOrderStatusText(order)) {
        const content4 = this.getOrderStatusContent(order);
        content = `${content1}<br/>${content2}<br/>${content3}<br/><br/>${content4}`;
      }
      this.bubbleContentHtml = content;
    },
    isShowOrderStatusText: function (order) {
      const type = getOrderStatusTextType(order);
      console.log(`type=${type}`);
      return type != ORDER_STATUS_TEXT_TYPE.NOTHING;
    },
    getOrderStatusContent: function (order) {
      const type = getOrderStatusTextType(order);
      const text = this.getOrderStatusText(order);
      if (type == ORDER_STATUS_TEXT_TYPE.IN_CONFIRM) {
        // 注文確認中
        return `<span class="text-body-2 blue--text">${text}</span>`;
      } else if (type == ORDER_STATUS_TEXT_TYPE.CANCELED) {
        // キャンセル
        return `<span class="text-body-2 red--text">${text}</span>`;
      }
      throw Error("not implemented");
    },
    getOrderStatusText: function (order) {
      const type = getOrderStatusTextType(order);
      console.log(`type=${type}`);
      if (type == ORDER_STATUS_TEXT_TYPE.IN_CONFIRM) {
        return "注文確認中";
      } else if (type == ORDER_STATUS_TEXT_TYPE.CANCELED) {
        return "注文キャンセル";
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
@import "../../css/bubble.css";
</style>
